import React from 'react';
import { getBezierPath, getSmoothStepPath, getStraightPath, MarkerType } from 'reactflow';
import {DeleteOutlined} from '@ant-design/icons';
import { Button } from 'antd';
import '../css/custom-edges.css';
import { getEdgeDeleteButtonVisibility, getEdgeDeleteButtonSize, getDeleteMode, getEdgeType} from './UserSettings';

let edgeDeleteButtonSize = getEdgeDeleteButtonSize();
let isEdgeDeleteButtonVisible = getEdgeDeleteButtonVisibility();

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd = {type: MarkerType.ArrowClosed, fill: "black"},
  data, 
}) {


  const [curveEdgePath,] = getBezierPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });
  const [straightEdgePath,] = getStraightPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });
  const [stepEdgePath,] = getSmoothStepPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });

  let foreignObject = <></>
  if (getDeleteMode() ) {
    foreignObject = <foreignObject
        name="deletebutton"
        width={edgeDeleteButtonSize}
        height={edgeDeleteButtonSize}
        x={((sourceX + targetX) - edgeDeleteButtonSize) / 2}
        y={((sourceY + targetY) - edgeDeleteButtonSize) / 2}
        className="edgebutton-foreignobject"
      >
        <body>
          {/* <button className="edgebutton" onClick={() => data.funcs.delEdge(id)}>
            ×
          </button> */}
          <Button icon={<DeleteOutlined style={{fontSize: "1.15em", paddingTop: "0.15em"}}/>}  className="aaa" size='small'  type="primary" danger={true} shape='circle' onClick={() => data.funcs.delEdge(id)}>

          </Button>
        </body>
    </foreignObject>
  }

  let path = <>
    <path
      id={id}
      style={style}
      className="react-flow__edge-path"
      d={getEdgeType() === "default" ? curveEdgePath : getEdgeType() === "straight" ? straightEdgePath : stepEdgePath}
      sourcePosition={sourcePosition}
      markerEnd={markerEnd}
    />
  </>

  if (!isEdgeDeleteButtonVisible) {
    return (
      path
    );
  } else {
    return (
      [path, foreignObject] // JSX elements must be wrapped in an array or fragment when returning multiple elements.
    );
  }
}
